export default function formatNumber(number: number | string): string {
  return `${number}`.replace('.', ',');
}
